
import { Component, Vue, Prop } from 'vue-property-decorator'

import companyModule from '@/store/company'
import { TextFieldRules } from '@/utils/enums'
import whitelabel from '@/store/whitelabel'

@Component({
  name: 'PartnerEditor'
})
class PartnerEditor extends Vue {
  @Prop() readonly edit?: boolean

  public rules = TextFieldRules

  public form = {
    email: '',
    isLight: false
  }

  get whitelabel() {
    return whitelabel.whitelabel
  }

  public get partner() {
    return companyModule.partner!
  }

  public created() {
    if (this.edit) {
      this.form.email = this.partner!.email
    }
  }

  public linkPartner() {
    if (!this.edit) {
      companyModule.linkPartner({
        whitelabel: companyModule.company!.whitelabel,
        email: this.form.email,
        isLight: this.form.isLight
      })
      document.dispatchEvent(new Event('close-partner'))
    }
  }
}

export default PartnerEditor
